import getFetchStatusSelectors from './'


export default getFetchStatusSelectors('byUserId')
